(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["tx-home-expert"] && !Shopify.designMode) return;
  try {
    
const fittingDesktop = window.matchMedia('(min-width: 750px)');
function syncFittingAccordions() {
  document.querySelectorAll('[data-tx-fitting-accordion]').forEach((accordion) => {
    accordion.open = fittingDesktop.matches;
  });
}
syncFittingAccordions();
fittingDesktop.addEventListener('change', syncFittingAccordions);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tx-home-intent-rails"] && !Shopify.designMode) return;
  try {
    
(()=>{
  function init(root){
    if(!root||root.dataset.ready)return;
    const panels=[...root.querySelectorAll('[data-tx-intent-panel]')];
    const output=root.querySelector('[data-tx-combined-grid]');
    const combined=root.querySelector('[data-tx-combined]');
    const summary=root.querySelector('[data-tx-combined-summary]');
    const browse=root.querySelector('[data-tx-combined-link]');
    const sizeNote=root.querySelector('[data-tx-size-note]');
    const empty=root.querySelector('[data-tx-empty]');
    const prev=root.querySelector('[data-tx-intent-prev]');
    const next=root.querySelector('[data-tx-intent-next]');
    const buttons=[...root.querySelectorAll('[data-tx-intent-tab]')];
    const sizes=[...root.querySelectorAll('[data-tx-size]')];
    const stores=[...root.querySelectorAll('[data-tx-showroom]')];
    const groups={intent:buttons.filter(b=>b.dataset.txIntentGroup==='intent'),sleep:buttons.filter(b=>b.dataset.txIntentGroup==='sleep')};
    let copy={};
    try{copy=JSON.parse(root.querySelector('[data-tx-intent-copy]').textContent);}catch(_){return;}
    const money=new Intl.NumberFormat(document.documentElement.lang||'en-US',{style:'currency',currency:root.dataset.priceCurrency||'USD'});
    const format=cents=>money.format(cents/100);
    const panelMap=new Map();
    const pool=new Map();
    const normalSize=value=>{
      const text=String(value||'').trim().toLowerCase().replace(/[–—]/g,'-');
      if(/^split\s+(california|cal)\s+king\b/.test(text))return 'split california king';
      if(/^split\s+king\b/.test(text))return 'split king';
      if(/^(california|cal)\s+king\b/.test(text))return 'california king';
      if(/^twin\s*(xl|extra long)\b/.test(text))return 'twin xl';
      if(/^twin\b/.test(text))return 'twin';
      if(/^full\b|^double\b/.test(text))return 'full';
      if(/^queen\b/.test(text))return 'queen';
      if(/^king\b/.test(text))return 'king';
      return text;
    };
    panels.forEach(panel=>{
      const cards=[...panel.querySelectorAll('.tx-intent-card')];
      const handles=(panel.dataset.txIntentHandles||'').split('|').filter(Boolean);
      panelMap.set(panel.dataset.txIntentPanel,{handles,intro:panel.querySelector('.tx-intent-panel__intro p')?.textContent.trim(),link:panel.querySelector('.tx-intent-panel__intro a')});
      cards.forEach(card=>{
        let variants=[];
        try{variants=JSON.parse(card.querySelector('[data-tx-card-variants]').textContent);}catch(_){return;}
        const template=card.cloneNode(true);
        template.querySelectorAll('script').forEach(script=>script.remove());
        template.querySelectorAll('[data-shortlist-bound]').forEach(button=>delete button.dataset.shortlistBound);
        pool.set(card.dataset.productHandle,{template,variants});
      });
    });
    let intent='hot';
    let sleep='';
    let size='';
    let store='magnolia';
    const label=key=>buttons.find(button=>button.dataset.txIntentTab===key)?.textContent.trim()||key;
    const track=(event,detail)=>{
      window.dataLayer=window.dataLayer||[];
      window.dataLayer.push({event,source:'homepage_problem_journey',...detail});
    };
    function priceFor(item){
      const available=item.variants.filter(variant=>variant.available&&Number(variant.price)>0);
      let matches=size?available.filter(variant=>normalSize(variant.size)===size):available;
      let quantity=1;
      if(size==='split king'&&!matches.length){
        matches=available.filter(variant=>normalSize(variant.size)==='twin xl');
        quantity=2;
      }
      matches.sort((a,b)=>Number(a.price)-Number(b.price));
      if(!matches.length)return null;
      const variant=matches[0];
      return {variant,quantity,price:Number(variant.price)*quantity,compare:Number(variant.compare||0)*quantity};
    }
    function arrows(){
      const max=Math.max(0,output.scrollWidth-output.clientWidth);
      if(prev)prev.disabled=output.scrollLeft<=4;
      if(next)next.disabled=output.scrollLeft>=max-4;
    }
    function render(){
      const key=intent==='showroom'?'showroom_'+store.replace('-','_'):intent;
      const panel=panelMap.get(key)||panelMap.get(intent);
      const handles=panel?.handles||[];
      const sleepHandles=new Set(sleep?panelMap.get(sleep)?.handles||[]:[]);
      const selected=[];
      handles.forEach(handle=>{
        const item=pool.get(handle);
        if(!item||(sleep&&!sleepHandles.has(handle)))return;
        const pricing=priceFor(item);
        if(!pricing||(intent==='value'&&pricing.price>=150000))return;
        if(selected.some(entry=>entry.handle===handle))return;
        selected.push({handle,item,pricing});
      });
      selected.sort((a,b)=>a.pricing.price-b.pricing.price);
      output.replaceChildren();
      selected.slice(0,4).forEach(({item,pricing})=>{
        const card=item.template.cloneNode(true);
        const {variant,quantity,price,compare}=pricing;
        const sizeLabel=size?(sizes.find(button=>normalSize(button.dataset.txSize)===size)?.textContent.trim()||variant.size):variant.size;
        card.querySelector('[data-tx-price-label]').textContent=size?sizeLabel+' '+copy.from.toLowerCase():copy.from+' · '+sizeLabel;
        card.querySelector('[data-tx-price]').textContent=format(price);
        const was=card.querySelector('[data-tx-compare-price]');
        was.hidden=compare<=price;
        was.textContent=compare>price?format(compare):'';
        const sale=card.querySelector('[data-tx-sale]');
        sale.hidden=compare<=price;
        sale.textContent=compare>price?Math.round((compare-price)/compare*100)+'% OFF':'';
        card.querySelector('[data-tx-monthly]').textContent=format(price/48)+'/mo';
        card.querySelector('[data-tx-configuration]').textContent=variant.title+(quantity===2?' · '+copy.split:'');
        const badge=card.querySelector('.tx-intent-card__badges span:first-child');
        if(badge)badge.textContent=intent==='showroom'?label('showroom'):label(intent);
        const productUrl=card.dataset.productUrl+'?variant='+encodeURIComponent(variant.id);
        card.querySelectorAll('a').forEach(link=>link.setAttribute('href',productUrl));
        card.querySelector('.tx-intent-card__cta').textContent=quantity===2?copy.pairCta:copy.view;
        const save=card.querySelector('[data-tx-shortlist-toggle]');
        save.dataset.txComparePrice=String(price);
        save.dataset.txCompareUrl=productUrl;
        delete save.dataset.shortlistBound;
        output.appendChild(card);
      });
      combined.hidden=false;
      empty.hidden=selected.length>0;
      root.querySelector('[data-tx-showroom-filter]').hidden=intent!=='showroom';
      summary.textContent=(panel?.intro||'')+(sleep?' · '+label(sleep):'');
      if(panel?.link){browse.href=panel.link.getAttribute('href');browse.textContent=panel.link.textContent.trim();}
      sizeNote.textContent=size?(intent==='value'?copy.budget:copy.upgrades):copy.starting;
      if(window.__txShoppingPersonalizationBind)window.__txShoppingPersonalizationBind();
      root.querySelectorAll('[role="tablist"]').forEach(list=>{
        const options=[...list.querySelectorAll('[role="tab"]')];
        const active=options.find(option=>option.getAttribute('aria-selected')==='true')||options[0];
        options.forEach(option=>option.tabIndex=option===active?0:-1);
      });
      requestAnimationFrame(arrows);
    }
    buttons.forEach(button=>button.addEventListener('click',()=>{
      const group=button.dataset.txIntentGroup;
      const key=button.dataset.txIntentTab;
      if(group==='intent')intent=key;
      else sleep=sleep===key?'':key;
      groups[group].forEach(option=>option.setAttribute('aria-selected',option.dataset.txIntentTab===(group==='intent'?intent:sleep)?'true':'false'));
      track('sleep_need_selected',{filter_group:group,filter_value:group==='intent'?intent:sleep});
      render();
    }));
    sizes.forEach(button=>button.addEventListener('click',()=>{
      size=button.dataset.txSize?normalSize(button.dataset.txSize):'';
      sizes.forEach(option=>option.setAttribute('aria-selected',option===button?'true':'false'));
      track('sleep_need_selected',{filter_group:'size',filter_value:size||'all'});
      render();
    }));
    stores.forEach(button=>button.addEventListener('click',()=>{
      store=button.dataset.txShowroom;
      stores.forEach(option=>option.setAttribute('aria-selected',option===button?'true':'false'));
      render();
    }));
    root.querySelector('[data-tx-reset]').addEventListener('click',()=>{
      sleep='';size='';
      groups.sleep.forEach(button=>button.setAttribute('aria-selected','false'));
      sizes.forEach(button=>button.setAttribute('aria-selected',button.dataset.txSize?'false':'true'));
      render();
    });
    root.querySelectorAll('[role="tablist"]').forEach(list=>list.addEventListener('keydown',event=>{
      const options=[...list.querySelectorAll('[role="tab"]')];
      const current=options.indexOf(event.target);
      if(current<0||!['ArrowLeft','ArrowRight','Home','End'].includes(event.key))return;
      event.preventDefault();
      const index=event.key==='Home'?0:event.key==='End'?options.length-1:(current+(event.key==='ArrowRight'?1:-1)+options.length)%options.length;
      options[index].focus();options[index].click();
    }));
    const media=window.matchMedia('(max-width:749px)');
    const disclosures=[...root.querySelectorAll('[data-tx-mobile-disclosure]')];
    const sync=()=>disclosures.forEach(disclosure=>disclosure.open=!media.matches);
    sync();media.addEventListener('change',sync);
    const move=direction=>{
      const card=output.querySelector('.tx-intent-card');
      const gap=parseFloat(getComputedStyle(output).gap)||18;
      output.scrollBy({left:direction*(card?card.getBoundingClientRect().width+gap:output.clientWidth*.8),behavior:window.matchMedia('(prefers-reduced-motion:reduce)').matches?'auto':'smooth'});
    };
    prev?.addEventListener('click',()=>move(-1));next?.addEventListener('click',()=>move(1));
    output.addEventListener('scroll',arrows,{passive:true});
    window.addEventListener('resize',arrows,{passive:true});
    root.dataset.ready='true';
    render();
  }
  const all=()=>document.querySelectorAll('[data-tx-intent-rails]').forEach(init);
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',all);else all();
  document.addEventListener('shopify:section:load',all);
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tx-stearns-collection-2026"] && !Shopify.designMode) return;
  try {
    
function initStearnsCollections(scope){scope.querySelectorAll('[data-sf26]').forEach(root=>{if(root.dataset.sfReady)return;root.dataset.sfReady='true';const buttons=[...root.querySelectorAll('[data-sf-feel]')],cards=[...root.querySelectorAll('[data-sf-card]')],status=root.querySelector('[data-sf-status]');buttons.forEach(button=>button.addEventListener('click',()=>{const feel=button.dataset.sfFeel;buttons.forEach(item=>item.setAttribute('aria-pressed',String(item===button)));cards.forEach(card=>{card.hidden=feel!=='all'&&card.dataset.feel!==feel});status.textContent=feel==='all'?'':button.textContent.trim()+' · '+cards.filter(card=>!card.hidden).length;root.classList.toggle('sf26--filtered',feel!=='all')}))})}initStearnsCollections(document);document.addEventListener('shopify:section:load',()=>initStearnsCollections(document));

  } catch(e) { console.error(e); }
})();
})();
